import coupon128 from "@/assets/prize-3d/coupon-reveal-128.webp"
import coupon256 from "@/assets/prize-3d/coupon-reveal-256.webp"
import coupon512 from "@/assets/prize-3d/coupon-reveal-512.webp"
import { cn } from "@/lib/cn"

type CouponArtProps = {
  /** Rendered width and height in CSS pixels. */
  size: number
  /** Fades and desaturates the art for a coupon that does not work now. */
  muted?: boolean
  className?: string
}

/** The colour-agnostic 3D coupon (ivory ticket, champagne-gold % medallion), decorative, sharp at 1x to 3x. */
export function CouponArt({ size, muted = false, className }: CouponArtProps) {
  const src = size <= 64 ? coupon128 : coupon256
  return (
    <img
      src={src}
      srcSet={`${coupon128} 128w, ${coupon256} 256w, ${coupon512} 512w`}
      sizes={`${size}px`}
      width={size}
      height={size}
      alt=""
      aria-hidden
      draggable={false}
      decoding="async"
      className={cn("shrink-0 select-none object-contain", muted && "opacity-60 grayscale", className)}
    />
  )
}
